import { requests } from ".";
import { Configuration } from "../models/Configuration.model";

export const ConfigurationApi = {
  getConfiguration: () => requests.get<Configuration>('configuration')
};